import axios from 'axios';

export default {
    getDeclineStatuses() {
        return axios.get('/offer/get_decline_statuses');
    }
};
